// Design System
import Link from 'jl-design-system/elements/link/Link';
import { Message } from 'jl-design-system/components/message/Message';

// Types
import { UndeliverableServicesErrorProps } from './UndeliverableServicesError.types';

// Config
import routeConstants from '@constants/routeConstants';
import { getItemQuantityPhrase, pluraliseItemWord } from '@utils/helpers/pluraliseItem';

// Components
import Container from '@components/container';

const UndeliverableServicesError = ({ items = [] }: UndeliverableServicesErrorProps) => {
  if (items.length === 0) {
    return null;
  }

  const singleItem = items.length === 1;
  const messageTitle = `Sorry, the following ${pluraliseItemWord(singleItem)} cannot be delivered to your address`;
  const itemsList = (
    <ul>
      {items.map((item) => (
        <li key={item.id}>{item.name}</li>
      ))}
    </ul>
  );
  const messageBody = (
    <>
      {itemsList}
      <p>
        It&apos;s likely that the issue is due to an installation service that isn&apos;t available in your location.
      </p>
      <p>
        You can either remove {getItemQuantityPhrase(singleItem)} from your basket, or try removing the installation
        services if you would still like to purchase {getItemQuantityPhrase(singleItem)} without them.
      </p>
      <Link to={routeConstants.EDIT_BASKET}>Edit basket</Link>
    </>
  );

  return (
    <Container marginBottom="2">
      <Message body={messageBody} dataTestId="undeliverable-services-message" title={messageTitle} type="error" />
    </Container>
  );
};

export default UndeliverableServicesError;
